import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import { ReactNode } from "react";
import CopyIcon from "@mui/icons-material/ContentCopy";

interface CopyButtonProps {
    loading: boolean;
    onClick: () => void;
    disabled?: boolean;
    label?: ReactNode
}

export const CopyButton: React.FC<CopyButtonProps> = ({ loading, disabled = false, onClick, label }) => {
    return (
        <LoadingButton
            loading={loading}
            size="small"
            color="success"
            variant="contained"
            disabled={disabled}
            startIcon={<CopyIcon />}
            onClick={onClick}
        >
            {label ? label : <Localized id="copy">_copy</Localized>}
        </LoadingButton>
    );
};
